import defaults from '@mailobj-browser/front/js/selectors/defaults.js'
import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import { keyDown } from '@mailobj-browser/front/js/events/types/types.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import globals from '#utilities/js/ea/globals.js'
import preventDefault from '@mailobj-browser/front/js/events/hooks/preventDefault.js'

let msg, callback

const onKeyDown = object(listener, {
  type: keyDown,
  task: async (
    elem,
    event
  ) => {
    if (event.key === 'F5') {
      preventDefault(event)

      if (msg) {
        if (confirm(msg)) {
          globals.ea_link_msg_set(null)
          await callback?.()
          defaults.document.location.reload()
        }
      } else {
        defaults.document.location.reload()
      }
    }
  }
})

export const refresh = (m, c) => {
  msg = m
  callback = c
}

export default elem => {
  onKeyDown.listen(defaults.document.body)
}
